import State from '../core/State';
import { VisitorData } from '@kaizenplatform/intelligence-entity';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const startFetchingVisitor = () =>
  produce((draft: Draft<State>) => {
    draft.visitor.fetching = draft.visitor.fetching + 1;
  });

export const setVisitor = (salesData: VisitorData) =>
  produce((draft: Draft<State>) => {
    draft.visitor.data = salesData;
  });

export const finishFetchingVisitor = () =>
  produce((draft: Draft<State>) => {
    draft.visitor.fetching = draft.visitor.fetching - 1;
  });

export const disposeVisitor = () =>
  produce((draft: Draft<State>) => {
    draft.visitor.data = initialState.visitor.data;
    draft.visitor.fetching = initialState.visitor.fetching;
  });
